import { Skeleton as AntSkeletion } from 'antd';
import React from 'react';
import styled from 'styled-components';
// used in Project Summary (in status updates templates)
export const Skeleton = styled(AntSkeletion)`
  .ant-skeleton-title {
    width: 70% !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .ant-skeleton-content .ant-skeleton-title {
    border-radius: 0;
  }
  .ant-skeleton-content {
    display: flex !important;
    width: 100%;
    vertical-align: top;
    align-items: center !important;
    height: var(--spacing-06);
  }
`;
export const TagSkeletion = styled(AntSkeletion.Button)`
  & .ant-skeleton-button {
    max-height: var(--spacing-06);
    width: 60px;
  }
`;
export const TextSkeleton = styled(AntSkeletion)`
  max-height: var(--spacing-07) !important;
  .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
    margin-top: 0 !important;
  }
  .ant-skeleton-title {
    width: 30% !important;

    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .ant-skeleton-content .ant-skeleton-title {
    border-radius: 0;
  }
  .ant-skeleton-content {
    height: var(--spacing-06);
    display: flex;
    align-items: center;
  }
`;
export const ProgressWrapper = styled.div`
  position: relative;
  height: var(--spacing-07);
`;
export const ProgressSkeletionShort = styled(Skeleton)`
  position: absolute;
  width: 30%;
  top: 0;
`;
const ProgressSkeletionLong = styled(Skeleton)`
  position: absolute;
  width: 100%;

  top: 0;
`;

export const ProgressSkeletion = () => {
  return (
    <ProgressWrapper>
      <ProgressSkeletionShort paragraph={{ rows: 0 }} />
      <ProgressSkeletionLong paragraph={{ rows: 0 }} />
    </ProgressWrapper>
  );
};
